export const authTranslation = {
  title: {
    verify_account: 'Enter your email',
    login: 'Log into your account',
    register: 'Create your account',
  },
};